<style scoped>
</style>

<template>
  <section class="container">

    <portal-box class="has-text-centered-fullhd">
    <!--<img src="../../assets/images/print_tela_video_instutucional.png"/>-->
      <iframe width="100%" height="480" :src="link" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </portal-box>
  </section>
</template>

<script>
  export default {
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/video_institucional').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    computed: {
      link () {
        return this.$store.state.parametros.LINK_VIDEO_INSTITUCIONAL
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/VideoInstitucional/Dashboard.vue